import { TableToolbar } from "@/components/ui/table-toolbar";
import { TableSearchInput } from "@/components/ui/table-search-input";
import { FilterPill } from "@/components/ui/filter-bar";
import { SortDropdown } from "@/components/ui/sort-dropdown";
import {
  PERSONA_SORT_OPTIONS,
  type PersonaSortKey,
  type PersonaStatusFilter,
} from "./personas-tab-types";

interface PersonasToolbarProps {
  totalCount: number;
  searchQuery: string;
  onSearchChange: (val: string) => void;
  statusFilter: PersonaStatusFilter;
  onStatusFilterChange: (val: PersonaStatusFilter) => void;
  sortKey: PersonaSortKey;
  onSortChange: (val: PersonaSortKey) => void;
  hasActiveFilters: boolean;
  onResetFilters: () => void;
}

export function PersonasToolbar({
  totalCount,
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  sortKey,
  onSortChange,
  hasActiveFilters,
  onResetFilters,
}: PersonasToolbarProps) {
  return (
    <TableToolbar
      hasActiveFilters={hasActiveFilters}
      onResetFilters={onResetFilters}
      count={
        <span>
          <strong className="text-foreground">{totalCount}</strong> persona
          {totalCount !== 1 ? "s" : ""}
        </span>
      }
      actions={
        <SortDropdown
          options={PERSONA_SORT_OPTIONS}
          value={sortKey}
          onChange={onSortChange}
        />
      }
    >
      <TableSearchInput
        placeholder="Search personas..."
        value={searchQuery}
        onChange={onSearchChange}
        ariaLabel="Search personas"
      />
      <FilterPill
        ariaLabel="Filter by status"
        value={statusFilter}
        onValueChange={(v) =>
          onStatusFilterChange(v as "all" | "active" | "archived")
        }
        options={[
          { value: "all", label: "All statuses" },
          { value: "active", label: "Active" },
          { value: "archived", label: "Archived" },
        ]}
      />
    </TableToolbar>
  );
}
